import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";

export default function DropdownlistDisabledComponent({
  propsData,
  name,
  ddlData,
}) {
  const { handleChange, values } = propsData;

  const sendDataToParent = (event) => {
    handleChange(event);
  };

  return (
    <Box
      component="form"
      sx={{
        "& .MuiTextField-root": { width: "100%" },
      }}
      noValidate
      autoComplete="off"
    >
      <TextField
        select
        value={values[name]}
        onChange={sendDataToParent}
        name={name}
        disabled
      >
        {ddlData.map((option) => (
          <MenuItem key={option.value} value={option.value} selected>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
}
